module.exports = __webpack_public_path__ + "img/中国本社： 营口博愛医薬连锁有限公司：http：／／www.boaiyiyao.com 香港支社： 博愛(香港)有限会社：ht.ff82e050.png";